// @ts-strict-ignore
import { ArticleNode } from '../../article/presenter/article-node';
import { ArrayUtils } from '@shared/util/array-utils';
import { ContainerService } from '@3d-scene/model3d/container.service';

export class ProjectContentTreeUtils {
  public static ACCESSORIES_NODE_ID: string = 'ACCESSORIES_NODE';
  private static DRILLING_HOLES_NODE_ID: string = 'DRILLING_HOLES_NODE';

  public static createDrillingHolesNode(containerService: ContainerService, parentNode: ArticleNode = null): ArticleNode {
    return new ArticleNode(containerService, ProjectContentTreeUtils.DRILLING_HOLES_NODE_ID, parentNode);
  }

  public static isDrillingHolesNode(node: ArticleNode): boolean {
    if (!node) {
      return false;
    }
    return node.id === this.DRILLING_HOLES_NODE_ID;
  }

  public static createAccessoriesNode(containerService: ContainerService, parentNode: ArticleNode): ArticleNode {
    return new ArticleNode(containerService, ProjectContentTreeUtils.ACCESSORIES_NODE_ID, parentNode);
  }

  public static isAccessoriesNode(node: ArticleNode): boolean {
    if (!node) {
      return false;
    }
    return node.id === this.ACCESSORIES_NODE_ID;
  }

  public static findAccessoriesNode(articleNodes: ArticleNode[]): ArticleNode {
    if (!articleNodes) {
      return null;
    }
    for (const node of articleNodes) {
      if (ProjectContentTreeUtils.isAccessoriesNode(node)) {
        return node;
      }
    }
    return null;
  }

  public static clearArticleNodeLabelsCache(articleNodes: ArticleNode[]) {
    if (ArrayUtils.isEmpty(articleNodes)) {
      return;
    }
    for (const articleNode of articleNodes) {
      articleNode.articleTreeLabel = null;
      if (ArrayUtils.isNotEmpty(articleNode.children)) {
        ProjectContentTreeUtils.clearArticleNodeLabelsCache(articleNode.children);
      }
    }
  }

  public static clearArticleNodeDataTipsCache(articleNodes: ArticleNode[]) {
    if (ArrayUtils.isEmpty(articleNodes)) {
      return;
    }
    for (const articleNode of articleNodes) {
      articleNode.articleTreeDataTip = null;
      if (ArrayUtils.isNotEmpty(articleNode.children)) {
        ProjectContentTreeUtils.clearArticleNodeDataTipsCache(articleNode.children);
      }
    }
  }
}
